import React from 'react';
import { routes } from "./routing/routing";
import HomeTemplate from "./template/HomeTemplate";
import { BrowserRouter, Switch } from "react-router-dom";
// styles
import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss?v=1.2.0";
import "assets/demo/demo.css?v=1.2.0";
import "./Resources/css/styles.css";
import "react-image-gallery/styles/css/image-gallery.css";
import 'nprogress/nprogress.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

function App() {
  const showHomeTemplate = (routes) => {
    if(routes && routes.length > 0) {
      return routes.map((item,index)=>{
        return(
          <HomeTemplate
            key = {index}
            exact = {item.exact}
            path = {item.path}
            Component = {item.component}
          />
        )
      })
    }
  }
  return (
    <BrowserRouter>
      <Switch>
        {showHomeTemplate(routes)}
      </Switch>
    </BrowserRouter>
  );
}

export default App;
